import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useInterval, useEffectOnce, useRafLoop, useMedia } from 'react-use'

import { mediaM, mediaShort } from 'styled'

import slide_1 from 'assets/intro-slider/slide_1.jpg'
import slide_2 from 'assets/intro-slider/slide_2.jpg'
import slide_3 from 'assets/intro-slider/slide_3.jpg'
import slide_4 from 'assets/intro-slider/slide_4.jpg'
import slide_5 from 'assets/intro-slider/slide_5.jpg'

const Root = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: calc(100vw + 180px);
  opacity: ${({ ready }) => (ready ? 1 : 0)};
  transition: opacity 2s;
  z-index: -1;

  ${mediaM`
    height: 100%;
    `};
`

const SlideRoot = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ bg }) => bg};
  opacity: ${({ selected }) => (selected ? 1 : 0)};
  transition: opacity 2s;

  &:after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: right bottom;
    background-image: url(${({ url }) => url});

    ${mediaM`
      background-size: auto 100%;
    `};

    ${mediaShort`
      right: 200px;
    `};
  }
`
const slides = [
  { image: slide_1, bg: '#569bc4' },
  { image: slide_2, bg: '#a9b400' },
  { image: slide_3, bg: '#ef7625' },
  { image: slide_4, bg: '#6365af' },
  { image: slide_5, bg: '#00a3d6' },
]

const numSlides = slides.length

const Slide = ({ slide, selected, imageLoaded }) => {
  const [src, setSrc] = useState()

  useEffectOnce(() => {
    const img = new Image()
    img.addEventListener('load', () => {
      imageLoaded()
      setSrc(slide.image)
    })
    img.src = slide.image
  })
  return <SlideRoot url={src} selected={selected} bg={slide.bg}></SlideRoot>
}

const BackgroundSlider = ({ onReady, headerBg, toggleHeaderBg }) => {
  const [numLoaded, setNumLoaded] = useState(0)
  const [selectedSlide, setSelectedSlide] = useState(0)
  const isWide = useMedia('(min-width: 1024px)')

  const rootRef = useRef()

  const [loopStop, loopStart] = useRafLoop(() => {
    if (rootRef.current) {
      const bBox = rootRef.current.getBoundingClientRect()
      if (bBox.bottom < 60 && !headerBg) {
        toggleHeaderBg(true)
      } else if (bBox.bottom >= 60 && headerBg) {
        toggleHeaderBg(false)
      }
    }
  })

  useInterval(() => {
    setSelectedSlide((numSlides + selectedSlide + 1) % numSlides)
  }, 8000)

  const incrementLoaded = () => {
    setNumLoaded(num => {
      return num + 1
    })
  }

  useEffect(() => {
    if (numLoaded === slides.length) {
      onReady()
    }
  }, [numLoaded, onReady])

  useEffect(() => {
    if (isWide) {
      loopStop()
    } else {
      loopStart()
    }
  }, [isWide, loopStop, loopStart])

  return (
    <Root ready={numLoaded === slides.length} ref={rootRef}>
      {slides.map((slide, id) => (
        <Slide
          key={slide.image}
          slide={slide}
          selected={selectedSlide === id}
          imageLoaded={incrementLoaded}
        ></Slide>
      ))}
    </Root>
  )
}

export default BackgroundSlider
